import { EntityRequestBiztrip } from "../../entity/EntityRequestBiztrip";

export class DtoRequestBiztripsPostRes extends EntityRequestBiztrip {}
